const hintsReducer = (state = {}, action) => {
  switch (action.type) {
    case 'HINT_SEEN': {
      return {
        ...state,
        [action.hint]: true,
      };
    }
    default:
      return state;
  }
};

export default hintsReducer;
